import { getIsInfinity } from '@/components/layout/sidebar/StatusBox/statusbox.utils';
import { HEALTH_DISPLAY } from '@/constants';
import { getDisplayedHealthPercent } from '@/utils/health-display';

/**
 * `status` stays in English because it also acts as a discriminator in styling
 * helpers. Render `statusKey` through the `notifications` namespace instead —
 * it is empty when there is no status to show.
 */
export const getHealthFactor = (percentage: number | null) => {
  if (percentage === null) {
    return {
      statusColor: '',
      rangeColor: '',
      status: '',
      statusKey: '',
    };
  }

  // In most cases we show rounded health value in UI.
  percentage = getDisplayedHealthPercent(percentage);

  if (getIsInfinity(percentage)) {
    return {
      statusColor: 'text-green-100',
      rangeColor: 'bg-green-100',
      status: 'Healthy',
      statusKey: 'status.health.healthy',
    };
  }

  if (!Number.isFinite(percentage)) {
    return {
      statusColor: '',
      rangeColor: '',
      status: '',
      statusKey: '',
    };
  }

  if (percentage >= HEALTH_DISPLAY.HEALTHY_MIN) {
    return {
      statusColor: 'text-green-100',
      rangeColor: 'bg-green-100',
      status: 'Healthy',
      statusKey: 'status.health.healthy',
    };
  } else if (percentage >= HEALTH_DISPLAY.MODERATE_MIN) {
    return {
      statusColor: 'text-yellow-100',
      rangeColor: 'bg-vault-caution',
      status: 'Moderate',
      statusKey: 'status.health.moderate',
    };
  } else {
    return {
      statusColor: 'text-red-100',
      rangeColor: 'bg-red-100',
      status: 'Risky',
      statusKey: 'status.health.risky',
    };
  }
};

export const getRangecolor = (percentage: number | null | undefined) => {
  if (percentage === null || percentage === undefined) {
    return '';
  }

  percentage = getDisplayedHealthPercent(percentage);

  // N/A case:
  if (Number.isNaN(percentage)) {
    return '#bbbbbb';
  }

  if (percentage >= HEALTH_DISPLAY.HEALTHY_MIN) {
    return '#59aa8a';
  } else if (percentage >= HEALTH_DISPLAY.MODERATE_MIN) {
    return '#fde37b';
  } else {
    return '#d04c68';
  }
};

export const getFeeColor = (status: string) => {
  if (status === 'Fast') {
    return '#59aa8a';
  } else if (status === 'Medium') {
    return '#fde37b';
  } else if (status === 'Slow') {
    return '#d04c68';
  } else {
    return '#d04c68';
  }
};
